import { AiGeneratedTagIcon } from '@kvdbil/components';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  DatoCmsTagList,
  useDatoCmsTags
} from '~/App/shared/hooks/useDatoCmsTags';
import { useTranslation } from '~/Locale';

const Wrapper = styled.div<{ $anchorToParent: boolean }>`
  position: ${({ $anchorToParent }) =>
    $anchorToParent ? 'static' : 'relative'};
`;

const StyledAiGeneratedTagIcon = styled(AiGeneratedTagIcon)`
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  z-index: 1;
  width: 3.4375rem;
  height: 2rem;
  color: ${({ theme }) => theme.colors.text.dark};
  pointer-events: none;
`;

type Props = {
  tags?: DatoCmsTagList;
  anchorToParent?: boolean;
  className?: string;
  children: ReactNode;
};

const AiGeneratedImageWrapper = ({
  tags,
  anchorToParent = false,
  className,
  children
}: Props) => {
  const { t } = useTranslation();
  const { isAiGenerated } = useDatoCmsTags(tags);

  return (
    <Wrapper className={className} $anchorToParent={anchorToParent}>
      {children}
      {isAiGenerated && (
        <StyledAiGeneratedTagIcon title={t('AI generated image')} />
      )}
    </Wrapper>
  );
};

export default AiGeneratedImageWrapper;
